import React, { Suspense } from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';

document.addEventListener('DOMContentLoaded', () => {
  const StickyCategories = React.lazy(() => import('../homepage/components/sticky_categories/StickyCategories'));
  createRoot(
    document.getElementById('react-sticky-categories'),
  ).render(
    <Suspense fallback="">
      <Provider store={window.store}>
        <StickyCategories />
      </Provider>
    </Suspense>,
  );
});
